module.exports = __webpack_public_path__ + "img/cheese.8f1142e8.svg";